<template>
	<div class="pop-main flex-row">
		<div class='account-info'>
			<div class='title'>账号信息</div>
			<div class='form-line'>
				<div class='form-name'>昵称：</div>
				<el-input size="small" v-model="form.nickname" class='form-inp'></el-input>
			</div>
			<div class='form-line'>
				<div class='form-name'>账号：</div>
				<el-input size="small" v-model="form.username" class='form-inp'></el-input>
				<el-tag type="private" style="cursor: pointer; user-select: none;" @click="randStr('phone')">随机</el-tag>
			</div>
			<div class='form-line'>
				<div class='form-name'>密码：</div>
				<el-input size="small" v-model="form.password" class='form-inp'></el-input>
				<el-tag type="private" style="cursor: pointer; user-select: none;" @click="randStr('password')">随机</el-tag>
			</div>
			<div class='form-line'>
				<div class='form-name'>粉丝：</div>
				<el-input size="small" v-model="form.fans" class='form-inp'></el-input>
			</div>
			<div class='form-line'>
				<div class='form-name'>头像：</div>
				 <el-image class='avatar' :src="avatar"></el-image>
				<el-tag type="private" style="cursor: pointer; user-select: none;" @click="randStr('avatar')">随机</el-tag>
				<el-tag type="success" style="cursor: pointer; user-select: none;" @click="uploadAvatar()">上传</el-tag>
			</div>
			<div class='form-line' style="margin: 20px 0;">
				<el-button type="primary" style="width: 300px; margin-top: 30px;" @click="submitAdd()">立即创建</el-button>
			</div>
			<div class="tip">* 如需创建连红账号，请先添加历史方案</div>
		</div>
		<div class='order-info'>
			<div class='title'>添加历史发单</div>
				<el-table :data="tableData" style="width: 100%" :row-class-name="tableRowClassName">
				<el-table-column prop="date" label="日期" align="center" width="100"></el-table-column>
				<el-table-column prop="lotteryName" label="彩种" align="center" width="100"></el-table-column>
				<el-table-column prop="betString" label="方案" align="center" width="300"></el-table-column>
				<el-table-column prop="multiplier" label="金额倍数" align="center" width="150">
					<template slot-scope="scope">
						{{scope.row.multiplier}}倍/{{scope.row.orderAmount}}元
					</template>
				</el-table-column>
				<el-table-column prop="numbers" label="跟单人数" align="center">
					<template slot-scope="scope">
						<el-input size="mini" align v-model="scope.row.numbers"></el-input>
					</template>
				</el-table-column>
				<el-table-column prop="amounts" label="跟单金额" align="center">
					<template slot-scope="scope">
						<el-input size="mini" v-model="scope.row.amounts"></el-input>
					</template>
				</el-table-column>
				<el-table-column prop="address" label="操作" align="center">
					<template slot-scope="scope">
						<el-tag type="danger" size="mini" style="cursor: pointer;"  @click="deletePlan(scope)">删除</el-tag>
					</template>
				</el-table-column>
			</el-table>
			<div class='form-line' style="margin: 20px 0;">
				<el-button type="primary" @click="addPlan()">添加历史方案</el-button>
			</div>
		</div>
		<el-dialog :visible.sync="addPlanShow" append-to-body v-if="addPlanShow" top="30px" width="1400px" :before-close="handleClose">
			<addPlan @addPlan="addPlanHandle"></addPlan>
		</el-dialog>
		<input ref="avatarInput" type="file" accept="image/*" style="display: none" @change="onAvatarChange"/>
	</div>
</template>

<script>
	import addPlan from './addPlan.vue';
	
	export default {
		components:{
			addPlan
		},
		data(){
			return {
				addPlanShow:false,
				form:{
					nickname:'',
					username:'',
					password:'123456',
					fans:0,
					avatar:''
				},
				tableData:[],
				avatar:'',
				headers:{
					Authorization:'',
				}
			}
		},
		created() {
			this.headers.Authorization = localStorage.getItem('access_token');
			this.randStr('avatar');
		},
		methods:{
			submitAdd(){
				if(this.form.nickname == ''){
					return this.$message('请输入昵称');
				}
				if(this.form.username == ''){
					return this.$message('请输入账号');
				}
				if(this.form.password == ''){
					return this.$message('请输入密码');
				}
				if(this.form.avatar == ''){
					return this.$message('请选择头像');
				}
				let _this = this;
				_this.$api.post("/Virtuals/addUser", {plan:JSON.stringify(this.tableData), ...this.form}).then(res=>{
					if(res.code == 200){
						this.$message({'type':'success', 'message':'创建成功'});
					}else{
						this.$message({'type':'error', 'message':'创建失败'});
					}
				})
			},
			async onAvatarChange(e) {
				const file = e.target.files && e.target.files[0]
				e.target.value = ''
				if (!file) return
				if (!file.type.startsWith('image/')) {
					Message.error('请选择图片文件')
					return
				}
				const maxSizeMB = 10
				if (file.size > maxSizeMB * 1024 * 1024) {
					Message.warning(`图片大小超过 ${maxSizeMB}MB，建议先压缩后再上传`)
					return;
				}
		
				try {
					this.uploading = true
					this.uploadProgress = 0
					let uploadFile = file
					const form = new FormData()
					form.append('file', uploadFile)
					const res = await this.$api.post('/Upload/uploadImage', form, {
						onUploadProgress: progressEvent => {
							if (progressEvent.lengthComputable) {
								this.uploadProgress = Math.round((progressEvent.loaded / progressEvent.total) * 100)
							}
						}
					})
					if(res.code == 200){
						this.form.avatar = res.data.shortUrl;
						this.avatar = res.data.url
					}else{
						this.$message('上传失败')
					}
				} catch (err) {
					this.$message('上传失败')
				} finally {
					this.uploading = false
					this.uploadProgress = 0
				}
			},
			uploadAvatar(){
				this.$refs.avatarInput.click()
			},
			randStr(_tg){
				if(_tg == 'phone'){
					return this.form.username = this.generatePhoneCN();
				}
				if(_tg == 'password'){
					return this.form.password = this.generatePassword();
				}
				if(_tg == 'avatar'){
					let _this = this;
					_this.$api.get("/Admin/getRandAvatar", {}).then(res=>{
						if(res.code == 200){
							_this.form.avatar = res.data.short_url;
							_this.avatar = res.data.url;
						}
					})
				}
			},
			generatePhoneCN() {
			  // 常见第二位号段：3-9 （排除了 0,1,2）
			  const second = String.fromCharCode(51 + Math.floor(Math.random() * 7)); // '3'..'9'
			  // 剩余9位随即数字
			  let rest = '';
			  for (let i = 0; i < 9; i++) rest += Math.floor(Math.random() * 10);
			  return '1' + second + rest;
			},
			generatePassword(options = {}) {
			  const { strength = 'strong', length } = options;
			  const num = '0123456789';
			  const lower = 'abcdefghijklmnopqrstuvwxyz';
			  const upper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
			  const special = '!@#$%^&*()-_=+[]{};:,.<>?/~`';
			  if (strength === 'weak') {
			    const L = length || 8;
			    // mostly digits, maybe letters
			    const charset = num + lower;
			    return this.randomFromCharset(charset, L);
			  }
			  if (strength === 'medium') {
			    const L = length || 10;
			    const charset = lower + upper + num;
			    // ensure at least one lower, one upper, one digit
			    return this.ensurePattern(charset, L, { lower, upper, num });
			  }
			  if (strength === 'strong') {
			    const L = length || (12 + Math.floor(Math.random() * 5)); // 12-16
			    const charset = lower + upper + num + special;
			    // ensure variety
			    return this.ensurePattern(charset, L, { lower, upper, num, special });
			  }
			  if (strength === 'custom') {
			    const charset = options.chars || (lower + upper + num);
			    const L = length || 12;
			    return this.randomFromCharset(charset, L);
			  }
			  // fallback
			  return this.generatePassword({ strength: 'strong', length: 12 });
			},
			randomFromCharset(charset, len) {
			  let s = '';
			  for (let i = 0; i < len; i++) {
			    s += charset.charAt(Math.floor(Math.random() * charset.length));
			  }
			  return s;
			},
			ensurePattern(charset, len, requiredSets = {}) {
			  const requiredChars = [];
			  for (const key in requiredSets) {
			    const set = requiredSets[key];
			    if (!set || set.length === 0) continue;
			    requiredChars.push(set.charAt(Math.floor(Math.random() * set.length)));
			  }
			  const remain = Math.max(0, len - requiredChars.length);
			  let rest = '';
			  for (let i = 0; i < remain; i++) {
			    rest += charset.charAt(Math.floor(Math.random() * charset.length));
			  }
			  // 混合打乱顺序
			  const arr = (requiredChars.join('') + rest).split('');
			  for (let i = arr.length - 1; i > 0; i--) {
			    const j = Math.floor(Math.random() * (i + 1));
			    [arr[i], arr[j]] = [arr[j], arr[i]];
			  }
			  return arr.join('');
			},
			deletePlan(scope){
				this.tableData.splice(scope.$index, 1);
			},
			addPlanHandle(e){
				let _t = e;
				_t.numbers = 0;
				_t.amounts = 0;
				this.tableData.push(_t)
				this.addPlanShow = false;
			},
			addPlan(){
				this.addPlanShow = true;
			},
			handleClose(){
				this.addPlanShow = false;
			},
			tableRowClassName({row, rowIndex}) {
				if (rowIndex === 1) {
					return 'warning-row';
				} else if (rowIndex === 3) {
					return 'success-row';
				}
				return '';
			}
		}
	}
</script>

<style scoped lang="scss">
	.flex-row {
		display: flex; flex-direction: row; align-items: flex-start; justify-content: space-between;
	}
	.pop-main {
		height: 800px;
	}
	.account-info {
		padding: 20px;
		border-radius: 10px;
		width: 310px;
		background-color: #f8f8f8;
	}
	.order-info {
		padding: 20px;
		border-radius: 10px;
		width: 950px;
		background-color: #f8f8f8;
	}
	.title {
		font-weight: bold;
		font-size: 18px;
		color: black;
		margin-bottom: 20px;
	}
	.form-line {
		margin: 10px 0;
		display: flex; flex-direction: row; align-items: center;
		.form-name {
			width: 50px;
			font-size: 16px;
		}
		.form-inp {
			width: 200px;
			margin-right: 10px;
		}
		.avatar {
			width: 60px; height: 60px; border-radius: 60px;
			margin-right: 10px;
		}
	}
	.tip {
		color: orangered;
	}
	
</style>
<style>
	.el-table .warning-row {
		background: oldlace;
	}
	
	.el-table .success-row {
		background: #f0f9eb;
	}
</style>